const setOfUniqueNames = new Set();
export class SkanfilEventSubscription {
    constructor(_event, _listener) {
        this._event = _event;
        this._listener = _listener;
    }
    get listener() {
        return this._listener;
    }
    unSubscribe() {
        window.removeEventListener(this._event, this._listener, false);
    }
}
export class SkanfilEvent {
    constructor(name) {
        if (setOfUniqueNames.has(name)) {
            throw new Error(`There is already an event with the name ${name}`);
        }
        this.name = name;
        setOfUniqueNames.add(name);
    }
    trigger(data) {
        window.dispatchEvent(new CustomEvent(this.name, { detail: data }));
    }
    subscribe(callback) {
        const subscription = new SkanfilEventSubscription(this.name, (e) => callback(e.detail));
        window.addEventListener(this.name, subscription.listener, false);
        return subscription;
    }
}
class SkanfilPopStateEvent {
    subscribe(callback) {
        window.addEventListener("popstate", (e) => {
            if (!e.state)
                return;
            callback(e.state);
        });
    }
}
const events = {
    singleStampItemSelected: new SkanfilEvent('single-stamp-item-selected'),
    openLogin: new SkanfilEvent('login-open'),
    onCurrencyChanged: new SkanfilEvent('currency-changed'),
    onBottomMenuShow: new SkanfilEvent('bottom-menu-show'),
    onCartBadgeUpdate: new SkanfilEvent('cart-badge-update'),
    onBasketUpdated: new SkanfilEvent('basket-updated'),
    setBackdrop: new SkanfilEvent('set-backdrop'),
    onPopState: new SkanfilPopStateEvent(),
    onAuctionItemBid: new SkanfilEvent('auction-item-bid'),
    onUpdateMyFavorite: new SkanfilEvent('update-favorite'),
    onShowSaveSearch: new SkanfilEvent('show-save-search'),
};
export default events;
